import React from 'react';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik } from 'formik';
import * as yup from 'yup';

export default function CreateZoneModal(props) {
  const { onSubmit, formdata, ...rest } = props;

  const schema = yup.object().shape({
    name: yup.string().required('กรุณากรอกชื่อโซน'),
    prefix: yup.string().required('กรุณากรอกตัวย่อโซน'),
    table_capacity: yup
      .number()
      .typeError('จำนวนโต๊ะต้องเป็นตัวเลข')
      .required('กรุณากรอกจำนวนโต๊ะ')
      .min(1, 'จำนวนโต๊ะต้องมากกว่า 0')
      .integer('จำนวนโต๊ะต้องเป็นจำนวนเต็ม'),
    seat_capacity: yup
      .number()
      .typeError('จำนวนที่นั่งต้องเป็นตัวเลข')
      .required('กรุณากรอกจำนวนที่นั่งในโต๊ะ')
      .min(1, 'จำนวนที่นั่งต้องมากกว่า 0')
      .integer('จำนวนที่นั่งต้องเป็นจำนวนเต็ม')
  });

  const initialValues = {
    name: '',
    prefix: '',
    table_capacity: '',
    seat_capacity: 4,
    is_active: true
  };

  return (
    <Modal {...rest} size="md" centered>
      <Modal.Body>
        <div className="d-flex align-items-center px-3 py-2 mb-4 pb-3">
          <div className="fs-24 fw-bold me-auto" style={{ color: '#2DC76D' }}>
            เพิ่มโซน/โต๊ะ
          </div>
          <button onClick={props.onHide} className="btn btn-close-modal"></button>
        </div>

        <div className="px-3">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={schema}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                const submitData = {
                  name: values.name,
                  prefix: values.prefix,
                  table_capacity: parseInt(values.table_capacity, 10),
                  seat_capacity: parseInt(values.seat_capacity, 10)
                };
                await onSubmit(submitData);
              } catch (error) {
                console.error('Error submitting form:', error);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ handleSubmit, handleChange, touched, errors, values, setFieldValue, isSubmitting }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Group className="mb-3 form-st-3 pb-1">
                  <Form.Label className="mb-1">
                    ชื่อโซน <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="ชื่อโซน"
                    value={values.name}
                    onChange={handleChange}
                    isInvalid={touched.name && !!errors.name}
                  />
                  <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3 form-st-3 pb-1">
                  <Form.Label className="mb-1">
                    ตัวย่อโซน <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="prefix"
                    className="form-control"
                    placeholder="ตัวย่อโซน"
                    value={values.prefix}
                    onChange={handleChange}
                    isInvalid={touched.prefix && !!errors.prefix}
                  />
                  <Form.Control.Feedback type="invalid">{errors.prefix}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3 form-st-3 pb-1">
                  <Form.Label className="mb-1">
                    จำนวนโต๊ะ <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="table_capacity"
                    className="form-control"
                    placeholder="จำนวนโต๊ะ"
                    min="1"
                    value={values.table_capacity}
                    onChange={handleChange}
                    isInvalid={touched.table_capacity && !!errors.table_capacity}
                  />
                  <Form.Control.Feedback type="invalid">{errors.table_capacity}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3 form-st-3 pb-1">
                  <Form.Label className="mb-1">
                    ค่าเริ่มต้นจำนวนที่นั่งในโต๊ะ <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="seat_capacity"
                    className="form-control"
                    placeholder="เช่น 4"
                    min="1"
                    value={values.seat_capacity}
                    onChange={handleChange}
                    isInvalid={touched.seat_capacity && !!errors.seat_capacity}
                  />
                  <Form.Control.Feedback type="invalid">{errors.seat_capacity}</Form.Control.Feedback>
                </Form.Group>

                <Form.Label className="mb-2 tc-10">สถานะ</Form.Label>
                <div className="mb-3">
                  <Form.Check
                    inline
                    label="เปิดใช้งาน"
                    name="is_active"
                    type="radio"
                    id="active-true"
                    className="form-check-st-2 tc-7"
                    checked={values.is_active === true}
                    onChange={() => setFieldValue('is_active', true)}
                  />
                  <Form.Check
                    inline
                    label="ปิดใช้งาน"
                    name="is_active"
                    type="radio"
                    id="active-false"
                    className="form-check-st-2 tc-7"
                    checked={values.is_active === false}
                    onChange={() => setFieldValue('is_active', false)}
                  />
                </div>

                <div className="d-flex align-items-center pt-2 pb-3 btn-group-control">
                  <div className="me-auto"></div>
                  <Button
                    type="button"
                    className="btn-st-6 me-3"
                    style={{ width: '100px' }}
                    onClick={props.onHide}
                    disabled={isSubmitting}
                  >
                    ยกเลิก
                  </Button>
                  <Button type="submit" className="btn-st-3" style={{ width: '100px' }} disabled={isSubmitting}>
                    {isSubmitting ? 'กำลังบันทึก...' : 'บันทึก'}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
}
